import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API,
  // NOTE: withCredentials is intentionally OFF. Auth runs entirely via
  // `Authorization: Bearer <token>` (token persisted in localStorage by
  // AuthContext). Sending credentials would force iOS Safari / WebKit to
  // reject the response when the backend returns `Access-Control-Allow-
  // Origin: *` — per the CORS spec a credentialed request requires a
  // specific origin, not the wildcard, and Safari strictly enforces this
  // (Chrome on desktop is lenient). That mismatch was surfacing as
  // "Something went wrong. Please try again." on every iPhone login.
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("rv_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// Global 401 recovery: if any authenticated request fails with 401
// (token expired, revoked by "sign out others", or pre-feature stale token
// without iat), purge it from localStorage so we never send it again. The
// caller still gets the 401 to surface its own UX; we just stop the bleeding.
// Skipped for /auth/login so wrong-credentials doesn't wipe state mid-flow.
api.interceptors.response.use(
  (resp) => resp,
  (error) => {
    const status = error?.response?.status;
    const url = error?.config?.url || "";
    if (status === 401 && !url.includes("/auth/login") && localStorage.getItem("rv_token")) {
      localStorage.removeItem("rv_token");
    }
    return Promise.reject(error);
  }
);

export function formatApiError(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) {
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  }
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export default api;
